
import { InUseBy } from "@/types/caseField"
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

@Component({
	components: {
	}
})
export default class FormGroup extends Vue {
	@Prop({ type: String, default: "" })
	public label!: string;

	@Prop({ type: String, default: "" })
	public labelFor!: string;

	@Prop({ type: String, default: null })
	public description!: string | null;

	@Prop({ type: Boolean, default: false })
	public required!: boolean;

	@Prop({ type: String, default: "" })
	public requiredExtraText!: boolean;

	@Prop({ default: null })
	public inUseBy!: InUseBy | null

	@Prop({ default: null })
	public currentUserId!: string | null

	@Prop({ default: false })
	public saving!: boolean

	@Prop({ default: false })
	public waiting!: boolean

	@Prop({ default: null })
	public fieldError!: { error: string } | null

	private justSaved = false

	public get fieldDescription (): string | null {
		if (this.saving) {
			return "Saving"
		}

		if (this.justSaved) {
			return "Saved!"
		}

		if (this.description) {
			return this.description
		}

		if (this.inUseBy) {
			return this.currentUserId === this.inUseBy.id
				? "Editing"
				: `In use by: ${this.inUseBy.name}`
		}

		return null
	}

	public get descriptionClass (): string {
		if (this.justSaved) {
			return "badge badge-success"
		}

		if (this.inUseBy && this.currentUserId === this.inUseBy.id) {
			return "badge badge-info"
		}

		return "badge badge-danger"
	}

	@Watch("saving")
	onSavingChanged (saving: boolean, oldSaving: boolean) {
		if (oldSaving && !saving) { // Changed from true to false
			this.justSaved = true
			setTimeout(() => {
				this.justSaved = false
			}, 1000)
		}
	}
}
